import { Log } from 'ng2-logger';
import Types, { GlobalState } from '../../models/action/core.d';
import { IUserAddModalSetAction, IProjectFetchUsersOfGroupSetAction } from '../../models/action/project';
import * as Actions from '../constants/all';

const _logger = Log.create('Users');

const usersReducer = (state = GlobalState().users, action: Types.IAction) => {
    if (!state) {
        return state;
    }
    const newState: any = {};
    if (action.type === Actions.project.SET_USER_ADD_MODAL) {
        const payload = action as IUserAddModalSetAction;
        newState.addModalAllData = { results: payload.results, filters: payload.filters };
    }
    if (action.type === Actions.project.SET_PROJECT_FETCH_USERS_OF_GROUP) {
        const payload = action as IProjectFetchUsersOfGroupSetAction;
        newState.addModalSelectedData = { results: payload.results, filters: payload.filters };
    }
    return Object.assign({}, state, newState);
};

export default usersReducer;
